<div class="vendor-grid-dialog">
  <header>
    <div class="header-left">
      <h2>Vendor Locations</h2>
      <div class="hint">Check the locations each vendor delivers to. Changes save immediately.</div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <div *ngIf="!loading && !loadError" class="grid-scroll" (mouseleave)="clearHover()">
    <table>
      <thead>
        <tr>
          <th class="corner">Vendor</th>
          <th class="loc-header" *ngFor="let location of locations; let c = index"
              [class.hl]="c === hoverCol" [class.inactive]="location.active !== true">
            <div class="loc-name">{{location.name}}</div>
            <div class="loc-type" *ngIf="location.type !== 'retail'">{{location.type}}</div>
            <div class="loc-inactive" *ngIf="location.active !== true">inactive</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let vendor of vendors; let r = index">
          <th class="vendor-name" [class.hl]="r === hoverRow"
              (click)="toggleVendorAll(vendor)"
              title="Toggle every location for this vendor">
            {{vendor.name}}
            <span *ngIf="vendor.saving" class="count">Saving…</span>
            <span *ngIf="!vendor.saving" class="count" [class.partial]="servedCount(vendor) < activeLocationCount()">
              {{servedCount(vendor) === activeLocationCount() ? 'All' : servedCount(vendor) + '/' + activeLocationCount()}}
            </span>
          </th>
          <td *ngFor="let location of locations; let c = index" class="cell"
              [class.hl]="r === hoverRow || c === hoverCol"
              [class.on]="serves(vendor, location)"
              [class.inactive-col]="location.active !== true"
              (mouseenter)="setHover(r, c)"
              (click)="toggle(vendor, location)">
            <span class="mark" [class.off]="!serves(vendor, location)">{{serves(vendor, location) ? '&#10003;' : '&#10007;'}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
